import { InputBase } from '@mui/material'
import { useCallback, useEffect, useRef, useState } from 'react'
import { CustomCellEditorProps } from 'ag-grid-react'

export const CheckBoxCellEditor = (props: CustomCellEditorProps) => {
  const strToBool = useCallback((val?: string): boolean | undefined => {
    if (val === undefined) return undefined
    if (val.match(/^([tT]|check|1)/)) return true
    if (val.match(/^[fF]|0/)) return false
    return undefined
  }, [])

  const [value, setValue] = useState<boolean | undefined>(
    props.value === undefined
      ? undefined
      : !!props.value?.toString().match(/^([tT]|check|1)/)
  )
  const charPress = props.eventKey?.length === 1 ? props.eventKey : null
  const [text, setText] = useState(charPress ?? props.value ?? '')

  const inputRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    inputRef.current?.focus()
    if (charPress) {
      const newValue = strToBool(charPress)
      setValue(newValue)
      props.onValueChange(newValue)
    }
  }, [])

  return (
    <InputBase
      inputRef={inputRef}
      value={text}
      onChange={e => {
        const newValue = strToBool(e.target.value)
        setValue(newValue)
        setText(e.target.value)
        props.onValueChange(newValue)
      }}
    />
  )
}
